import { SortingQuestionPinAnswer } from '@lessonup/pins-shared';
import React from 'react';
import { SortingQuestionAnswerCard } from './components/SortingQuestionAnswerCard';
import { SortingQuestionAnswerAreaWrapper } from './components/SortingQuestionAnswerWrapper';

export interface SortingQuestionAnswerAreaContentProps {
  answers: Record<string, SortingQuestionPinAnswer>;
  order: string[];
  description?: string;
}

export const SortingQuestionAnswerAreaContent: React.FC<SortingQuestionAnswerAreaContentProps> = ({
  answers,
  order,
  description,
}) => {
  const orderedAnswers = order.map((id) => answers[id]);

  return (
    <SortingQuestionAnswerAreaWrapper description={description}>
      {orderedAnswers.map((answer, index) => (
        <SortingQuestionAnswerCard key={`${order[index]}`} index={index} answer={answer} />
      ))}
    </SortingQuestionAnswerAreaWrapper>
  );
};
